import React from 'react';
import { Link } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import VideocamIcon from '@mui/icons-material/Videocam';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import TerminalIcon from '@mui/icons-material/Terminal';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TechLogo from '../TechLogo';
import { technologies } from '../../data/learn';
import { blogPosts } from '../../data/blogPosts';

const lessonCount = technologies.reduce((sum, t) => sum + t.lessons.length, 0);

const PlatformBento = () => (
  <section className="home-section" id="about">
    <div className="container">
      <div className="home-section-head" data-reveal>
        <span className="section-eyebrow">One platform</span>
        <h2>Everything you need to go from learner to hired</h2>
        <p>Read the concepts, practise like it is the real interview, learn live with mentors, and walk in prepared.</p>
      </div>

      <div className="bento">
        <Link to="/learn" className="bento-card bento-learn spotlight" data-reveal style={{ '--i': 0 }}>
          <div className="bento-icon"><MenuBookIcon /></div>
          <span className="bento-tag bento-tag--free">Free</span>
          <h3>Learn</h3>
          <p>
            {lessonCount} in-depth lessons across {technologies.length} technologies, each with mental models,
            runnable examples, common mistakes, interview questions and practice.
          </p>
          <div className="bento-techs">
            {technologies.slice(0, 8).map((t) => (
              <span key={t.slug} title={t.name}><TechLogo tech={t} size={34} /></span>
            ))}
            <span className="bento-more">+{technologies.length - 8}</span>
          </div>
          <span className="bento-link">Start reading <ArrowForwardIcon sx={{ fontSize: 16 }} /></span>
        </Link>

        <Link to="/live-classes" className="bento-card bento-live spotlight" data-reveal style={{ '--i': 1 }}>
          <div className="bento-icon"><VideocamIcon /></div>
          <h3>Live Classes</h3>
          <p>Small, mentor-led cohorts with real-time doubt solving, projects and class recordings.</p>
          <span className="bento-link">See upcoming cohorts <ArrowForwardIcon sx={{ fontSize: 16 }} /></span>
        </Link>

        <Link to="/#interview-prep" className="bento-card bento-blog spotlight" data-reveal style={{ '--i': 2 }}>
          <div className="bento-icon"><WorkOutlineIcon /></div>
          <h3>Interview Prep</h3>
          <p>Real interview questions with answers, a playbook for every round, {blogPosts.length}+ guides and mock interviews.</p>
          <span className="bento-link">Start preparing <ArrowForwardIcon sx={{ fontSize: 16 }} /></span>
        </Link>

        <div className="bento-card bento-practice spotlight" data-reveal style={{ '--i': 3 }}>
          <div className="bento-icon"><TerminalIcon /></div>
          <span className="bento-tag">Coming soon</span>
          <h3>Practice</h3>
          <p>Solve real interview questions in the browser with instant test results, from JavaScript utilities to DSA problems.</p>
          <pre className="bento-terminal" aria-hidden="true"><code>{`✓ debounce: delays calls       12ms
✓ debounce: keeps last args     3ms
✓ debounce: preserves this      2ms

3 passed · Ready for the next one`}</code></pre>
        </div>
      </div>
    </div>
  </section>
);

export default PlatformBento;
